import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const EmailSettingsHeader = ({ product = {} }: { product: any }) => {
  const { version, technology, platform, name } = product;
  return (
    <Grid container alignItems="center" mb="20px">
      <Grid container item xs={12}>
        <Grid item xs={3}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            Account Name
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            {name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            Version
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            {version}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmailSettingsHeader;
